import Reflux from 'reflux';

export default Reflux.createActions(['openModal', 'closeModal']);



// WEBPACK FOOTER //
// ./app/actions/modalActions.jsx